module.exports = __webpack_public_path__ + "img/united-kingdom.9f129aa6.svg";